import React from 'react';
import {LoadingComponent} from '../../utils/ui'
import {getNameByLabel, getTeamworks, getWikies, getLastSectionPath} from '../../utils/emdUtil'
import WikiLink from '../wiki/WikiLink';
import { TEAMWORK, SIOC, RDFS } from '../../const/C';
/**
 * Предоставление информации о связанные с объектами ЕМД элементами коллективной работы
 * Элементы фиксируются в аннотации к элементу. Пример задания в VOWL 
 * 		"teamwork": [
 *			{
 *				"identifier": "teamwork",
 *				"type": "literal",
 *				"value": "http://62.61.8.56:8080/web/guest/rqm#/artifacts/30002",
 *				"language": "undefined"
 *			}
 *		],
 *		"wiki": [
 *			{
 *				"identifier": "wiki",
 *				"type": "literal",
 *				"value": "http://62.61.8.56:8080/web/guest/wiki/-/wiki/%D0%93%D0%BB%D0%BE%D1%81%D1%81%D0%B0%D1%80%D0%B8%D0%B9/%D0%9E%D0%BF%D0%B0%D1%81%D0%BD%D1%8B%D0%B9+%D1%85%D0%B8%D0%BC%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9+%D1%84%D0%B0%D0%BA%D1%82%D0%BE%D1%80",
 *				"language": "undefined"
 *			}
 *		]
 * 
 * Для более детальной информации передаётся список триплетов из объекта
 */
const TeamWork = ({value, triplet, content}) => {
	//Наименование определяем по значению до последнего слеша
	let name = decodeURIComponent(getLastSectionPath(value));
    let href = value;
   /** Парсинг URL, так как может быть wiki задана в анонимном узле */  
    if (triplet && triplet.o.type =="bnode")
        if (content && content.results && Array.isArray(content.results.bindings)){
          const bnodes = content.results.bindings.filter( item => item.s.value == value);
          //console.log("WikiLink.js parserURL()", bnodes);
          if (bnodes.length>0){
            const page = bnodes.filter(item => item.p.value == SIOC.PREDICAT_LINK);
            //console.log("WikiLink.js parserURL()", page);
            if (page.length>0){
              href = page[0].o.value;
            }
            const names = bnodes.filter(item => item.p.value == RDFS.PREDICAT_LABEL);
            if (names.length>0){
                name = names[0].o.value;
              }
            }
        }
    return (
        <div><a target="_blank" href={href} ><b>{name}</b></a></div>
	)
}

const TeamWorkTask = ({item}) => {
    const {annotations} = item;
    const task = annotations.identifierToAnnotation.task;
    const url = (Array.isArray(task)&&task.length>0)?task[0].value: "javascript:void(0)";
    return (
        <div><a target="_blank" href={url} ><b>{getNameByLabel(annotations)}</b></a></div>
    )
}

const TeamWorkRequiremet = ({item}) => {
    const {annotations} = item;
    const implementedBy = annotations.identifierToAnnotation.implementedBy;
    const url = (Array.isArray(implementedBy)&&implementedBy.length>0)?implementedBy[0].value: "javascript:void(0)";
    return (
        <div><a target="_blank" href={url} ><b>{getNameByLabel(annotations)}</b></a></div>
    )
}

/** Отображение информации о Wiki */
const TeamWorkWiki = ({item}) => {
		const {value} = item;
		//Наименование определяем по значению до последнего слеша
		const name = decodeURIComponent(getLastSectionPath(value));
    return (
        <div><a target="_blank" href={value} ><b>{name}</b></a></div>
    )
}

class CLMDiagramm extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            loading: false, 			//Флаг загрузки
        }
    }

    render() {
        //console.log("popUpCLM.js ", this);console.log(JSON.stringify(this.props.selected.item)); 
        const {selected, content} = this.props;
        const triplets =  (content && content.results && Array.isArray(content.results.bindings) && selected && selected.item && selected.item.iri)
            ? content.results.bindings.filter(item => (item.s.value == selected.item.iri)):[];
		const teamworks = triplets.filter(item => (item.p.value == TEAMWORK.PREDICAT_TW));
        const wikies = triplets.filter(item => (item.p.value == TEAMWORK.PREDICAT_WIKI));
		//const wikies = getWikies(selected);
        //console.log("popUpCLM.js ", teamworks); 
        //Список задания определяем по виду связи
        //const tasks = teamworks.filter (item => item&&item.annotations&&item.annotations.identifierToAnnotation&&item.annotations.identifierToAnnotation.task);
        //Список требований определяем по виду связи
        //const requirements = teamworks.filter (item => item&&item.annotations&&item.annotations.identifierToAnnotation&&item.annotations.identifierToAnnotation.implementedBy);
        console.log("popUpCLM.js ", this, teamworks, wikies); 
        return (
            <div>
                {(teamworks.length<1) && (wikies.length<1) &&(<p>Элементов коллективной работы нет.</p>)}
								{(teamworks.length>0)&&(
									<p><i>Элемент коллективной работы:</i>
											<ul style={{listStyle: "square"}}>
													{teamworks.map((tw, i)=> <li key={i}><TeamWork value={tw.o.value} triplet={tw} content={this.props.content} /></li>)}
											</ul>
									</p>
								)}
								{(wikies.length>0)&&(
									<p><i>Wiki статьи:</i>
											<ul style={{listStyle: "square"}}>
													{wikies.map((page, i)=> <li key={i}><WikiLink wiki={page.o.value} triplet={page} content={this.props.content}/></li>)}
											</ul>
									</p>
								)}
            </div>
        );
    }
};
// {(tasks.length>0)&&(
// 	<p><i>Задания:</i>
// 			<ul style={{listStyle: "square"}}>
// 					{tasks.map((tw, i)=> <li key={i}><TeamWorkTask item={tw} /></li>)}
// 			</ul>
// 	</p>
// )}
// {(requirements.length>0)&&(
// 	<p><i>Требования:</i>
// 			<ul style={{listStyle: "square"}}>
// 					{requirements.map((tw, i)=> <li key={i}><TeamWorkRequiremet item={tw} /></li>)}
// 			</ul>
// 	</p>
// )}

export default CLMDiagramm;